import type { NeonProvisionResult } from '@cli-types/next-adapter/vercel.js'
import type { NeonResourceMeta } from '@cli-types/next-adapter/vercel.js'
import { parseVercelJson } from '../runner/parse-vercel-json.js'

export function readNeonProvisionInfo(stdout: string): NeonProvisionResult {
  const meta = parseVercelJson<NeonResourceMeta>(stdout)
  if (!meta) return {}

  const info: NeonProvisionResult = {}
  if (meta.dashboardUrl) info.dashboardUrl = meta.dashboardUrl
  if (meta.ssoUrl?.resource) info.resourceUrl = meta.ssoUrl.resource
  return info
}
